// Pure helpers for the Network scans page: what to find out, how careful, and the request bodies.

// Scilla Ports was removed with the Scilla tool, so it is not offered.
export const KINDS = [
  { value: 'network_port_scan', label: 'Open ports', short: 'port scan', desc: 'Which ports answer on each host.' },
  { value: 'network_service_scan', label: 'Services', short: 'service scan', desc: 'What runs behind each open port, with banners.' },
  { value: 'network_cdn_scan', label: 'Hosting and CDN', short: 'hosting and CDN check', desc: 'Who hosts the IP, and whether a CDN hides it.' },
  { value: 'network_nettacker', label: 'Deep network scan', short: 'deep network scan', desc: 'Wide check for known weaknesses. Slowest.' }
];
export const kindLabel = (type) => KINDS.find((k) => k.value === type)?.label || String(type || '-').replaceAll('_', ' ');

export const CARE = [
  { id: 'quick', title: 'Quick', time: '~2 min', desc: 'Key ports, short timeouts. Light on the target.', policy: 'safe', timeout: '2' },
  { id: 'balanced', title: 'Balanced', time: '~8 min', desc: 'Common ports with normal timeouts.', policy: 'standard', timeout: '2' },
  { id: 'deep', title: 'Deep', time: '~25 min', desc: 'More time per host. Heavier on the target.', policy: 'aggressive', timeout: '4' }
];

const DEEP_OPTIONS = {
  profile: 'scan', modules: 'port_scan,http_status_scan,dir_scan,subdomain_scan', timeout: '8', thread_per_host: '100',
  parallel_module_scan: '5', set_hardware_usage: 'normal', retries: '2', user_agent: 'random_user_agent'
};

// Options for one scan type at one care level.
export function scanOptions(kind, care) {
  const c = CARE.find((x) => x.id === care) || CARE[1];
  if (kind === 'network_nettacker') return { ...DEEP_OPTIONS, network_policy: c.policy };
  if (kind === 'network_service_scan') return { network_policy: c.policy, timeout: c.timeout, banner_grab: true };
  if (kind === 'network_cdn_scan') return { network_policy: c.policy, timeout: c.timeout, ports: '80,443', max_ips: 512 };
  return { network_policy: c.policy, timeout: c.timeout, banner_grab: false };
}

// One POST body per host.
export function buildNetworkRequests({ kind, care, userTargetId, hosts }) {
  if (!hosts.length) throw new Error('Choose at least one host to scan.');
  const base = scanOptions(kind, care);
  return hosts.map((h) => ({
    user_target: userTargetId, scan_type: kind,
    options: { ...base, target_host: h.value, selected_asset_id: h.id === 'root' ? null : h.id, selected_asset_label: h.label || h.value, selected_asset_type: h.type || 'root' }
  }));
}

// Plain-language result for a finished run, from its findings.
export function runResult(scan, findings) {
  if (scan.status === 'failed') return (scan.error_message || 'Failed').slice(0, 80);
  if (scan.status === 'cancelled') return 'Stopped';
  if (['running', 'pending', 'paused'].includes(scan.status)) return scan.progress_message || 'Working…';
  const n = findings.length;
  if (scan.scan_type === 'network_port_scan') return `${n} open port${n === 1 ? '' : 's'}`;
  if (scan.scan_type === 'network_service_scan') return `${n} service${n === 1 ? '' : 's'} found`;
  if (scan.scan_type === 'network_cdn_scan') return findings[0]?.title || 'No hosting data';
  return `${n} finding${n === 1 ? '' : 's'}`;
}

export const portOf = (f) => {
  const m = String(f.title || '').match(/port\s+(\d+)/i);
  return m ? m[1] : f.raw_data?.port ? String(f.raw_data.port) : '';
};
